
define('text!templates/modules/member/member/modal/add-test-client-modal.html',[],function () { return '<p>\n    {{#t}}add-test-client-body{{/t}} <br><br>\n    <div class="remember-checkbox"></div>\n</p>\n';});

